export default (theme) => ({
  title: {
    fontSize: '22px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: 10,
  },
  data: {
    textAlign: 'right',
    width: '50%',
  },
  column: {
    width: '50%',
    fontWeight: 600
  },
  table: {
    width: '100%',
    borderSpacing: '10px'
  },
  defaultText: {
    height: 144,
    lineHeight: '144px',
    verticalAlign: 'middle',
    textAlign: 'center',
    fontSize: '18px',
    width: '100%'
  },
  expandButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  cardContent: {
    paddingBottom: [10, '!important'],
    position: 'relative',
  },
  clubIcon: {
    lineHeight: '13px'
  },
  clubText: {
    textAlign: 'left',
    paddingLeft: 10,
  },
  clubTable: {
    float: 'right'
  },
  gridContainer: {
    paddingBottom: '14px'
  },
  clubName: {
    marginTop: 5,
    fontSize: '18px'
  },
  addressPart: {
    marginTop: 0
  },
  bookText: {
    color: '#6f6f6f'
  },
  buttonContainer: {
    textAlign: 'center'
  },
  viewButton: {
    width: 108,
    marginRight: 5
  },
  cellContent: {
    textAlign: 'center'
  },
});
